import { Component } from 'preact';

class Profile extends Component {
	render(props, state) {
    let account = props.account
		return (
      <div>
         {account &&
           <div id="profile-container">
             <div id="profile-menu"  className={props.profileMenuOpen? "" : "hidden"} onClick={() => props.logoutCallbackWrapper()}>
               <span>Logout</span>
             </div>
             <div className="profile-img">
               <i className="fas fa-user"></i>
             </div>
             <div id="profile">
               <div id="profile-name"><span className={"overflow-ellipsis"}>{account.Name}</span></div>
               <div id="profile-title">{account.Role && account.Role.Name}</div>
             </div>
             <button className="settings-button" onClick={() => props.toggleProfileMenu()}>
               <i className="fas fa-cog"></i>
             </button>
           </div>
         }
      </div>
		);
	}
}

export {Profile};



// WEBPACK FOOTER //
// ./components/header/profile.js